<!-- Login drawer trigger button -->
@if (!user) {
<div class="login-drawer-trigger fixed right-0 z-90 flex h-10 w-10 cursor-pointer items-center justify-center rounded-l-lg bg-primary bg-opacity-90 shadow-lg print:hidden"
    style="top: 325px" (click)="loginDrawer.toggle()" matTooltip="Sign In">
    <mat-icon class="text-white icon-size-5" [svgIcon]="'heroicons_solid:user'"></mat-icon>
</div>
}

<!-- Login drawer -->
<fuse-drawer class="z-999 w-screen min-w-screen sm:w-100 sm:min-w-100" fixed [mode]="'over'" [name]="'loginDrawer'"
    [position]="'right'" #loginDrawer>
    <div class="bg-card flex w-full flex-col overflow-auto">
        <!-- Header -->
        <div class="flex h-20 min-h-20 flex-row items-center bg-primary px-6 text-white">
            <mat-icon class="text-current icon-size-7" [svgIcon]="'heroicons_solid:user'"></mat-icon>
            <div class="ml-3 text-2xl font-semibold tracking-tight">
                Sign In
            </div>
            <button class="ml-auto" mat-icon-button (click)="loginDrawer.close()">
                <mat-icon class="text-current" [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
            </button>
        </div>

        <!-- Content -->
        <div class="flex flex-col p-6">
            <!-- Logo -->
            <div class="flex justify-center mb-6">
                <div class="w-42">
                    <img src="images/logo/logo-text.png" />
                </div>
            </div>

            <!-- Welcome message -->
            <div class="text-center mb-6">
                <div class="text-2xl font-bold text-primary">
                    Welcome back!
                </div>
                <div class="text-secondary mt-1">
                    Please sign in to your account
                </div>
            </div>

            <!-- Alert -->
            @if (showAlert) {
            <fuse-alert class="mb-6" [appearance]="'outline'" [showIcon]="false" [type]="alert.type"
                [@shake]="alert.type === 'error'">
                {{ alert.message }}
            </fuse-alert>
            }

            <!-- Sign in form -->
            <form [formGroup]="signInForm" #signInNgForm="ngForm">
                <!-- Email field -->
                <mat-form-field class="w-full mb-4">
                    <mat-label>Email address</mat-label>
                    <input id="email" matInput [formControlName]="'email'" />
                    @if (signInForm.get('email').hasError('required')) {
                    <mat-error> Email address is required </mat-error>
                    }
                    @if (signInForm.get('email').hasError('email')) {
                    <mat-error>
                        Please enter a valid email address
                    </mat-error>
                    }
                </mat-form-field>

                <!-- Password field -->
                <mat-form-field class="w-full mb-4">
                    <mat-label>Password</mat-label>
                    <input id="password" matInput type="password" [formControlName]="'password'" #passwordField />
                    <button mat-icon-button type="button" (click)="
                            passwordField.type === 'password'
                                ? (passwordField.type = 'text')
                                : (passwordField.type = 'password')
                        " matSuffix>
                        @if (passwordField.type === 'password') {
                        <mat-icon class="icon-size-5" [svgIcon]="'heroicons_solid:eye'"></mat-icon>
                        }
                        @if (passwordField.type === 'text') {
                        <mat-icon class="icon-size-5" [svgIcon]="'heroicons_solid:eye-slash'"></mat-icon>
                        }
                    </button>
                    <mat-error> Password is required </mat-error>
                </mat-form-field>

                <!-- Submit button -->
                <button class="fuse-mat-button-large w-full mb-6" mat-flat-button [color]="'primary'"
                    [disabled]="signInForm.disabled" (click)="signIn()">
                    @if (!signInForm.disabled) {
                    <span> Sign In </span>
                    }
                    @if (signInForm.disabled) {
                    <mat-progress-spinner [diameter]="24" [mode]="'indeterminate'"></mat-progress-spinner>
                    }
                </button>

                <!-- Separator -->
                <div class="flex items-center mb-6">
                    <div class="flex-auto border-t"></div>
                    <div class="text-secondary mx-2 text-sm">Or continue with</div>
                    <div class="flex-auto border-t"></div>
                </div>

                <!-- Social sign-in buttons -->
                <div class="flex items-center space-x-3 mb-6">
                    <button class="flex-auto" type="button" mat-stroked-button>
                        <mat-icon class="icon-size-5" [svgIcon]="'feather:facebook'"></mat-icon>
                    </button>
                    <button class="flex-auto" type="button" mat-stroked-button>
                        <mat-icon class="icon-size-5" [svgIcon]="'feather:twitter'"></mat-icon>
                    </button>
                    <button class="flex-auto" type="button" mat-stroked-button>
                        <mat-icon class="icon-size-5" [svgIcon]="'feather:github'"></mat-icon>
                    </button>
                </div>

                <!-- Sign up link -->
                <div class="text-center">
                    <div class="text-sm text-secondary">
                        Don't have an account?
                        <a class="ml-1 text-primary-500 hover:underline font-medium" [routerLink]="['/sign-up']"
                            (click)="loginDrawer.close()">Sign up
                        </a>
                    </div>
                </div>
            </form>
        </div>
    </div>
</fuse-drawer>